import React from "react";
import { Helmet } from "react-helmet";

const TermsConditions = () => {
  return (
    <>
      <Helmet>
        <title>Sororin - Κατάστημα Ομορφιάς</title>
        <meta
          name="description"
          content="Sororin - Κατάστημα Ομορφιάς με προϊόντα υψηλής ποιότητας. Ανακαλύψτε την πολυτελή συλλογή μας από προϊόντα περιποίησης και ομορφιάς."
        />
      </Helmet>

      <div className="policy-container">
        <div className="policy-content">
          <h1>Όροι και Προϋποθέσεις Χρήσης</h1>
          <p className="last-updated">
            Τελευταία ενημέρωση: {new Date().toLocaleDateString("el-GR")}
          </p>

          <section>
            <h2>1. Αποδοχή Όρων</h2>
            <p>
              Καλώς ήρθατε στη Sororin. Χρησιμοποιώντας τον ιστότοπό μας και τις
              υπηρεσίες μας, συμφωνείτε να δεσμεύεστε από τους παρόντες Όρους
              και Προϋποθέσεις. Εάν δεν συμφωνείτε με οποιονδήποτε από αυτούς
              τους όρους, παρακαλούμε μην χρησιμοποιείτε τον ιστότοπό μας.
            </p>
            <p>
              Διατηρούμε το δικαίωμα να τροποποιούμε αυτούς τους όρους ανά πάσα
              στιγμή χωρίς προηγούμενη ειδοποίηση. Η συνεχής χρήση του ιστότοπου
              αποτελεί αποδοχή των τροποποιημένων όρων.
            </p>
          </section>

          <section>
            <h2>2. Χρήση του Ιστότοπου</h2>

            <h3>2.1 Επιτρεπόμενη Χρήση</h3>
            <p>
              Συμφωνείτε να χρησιμοποιείτε τον ιστότοπό μας μόνο για νόμιμους
              σκοπούς και με τρόπο που δεν παραβιάζει τα δικαιώματα τρίτων.
            </p>

            <h3>2.2 Απαγορευμένες Δραστηριότητες</h3>
            <p>Απαγορεύεται να:</p>
            <ul>
              <li>Χρησιμοποιείτε τον ιστότοπο με παράνομο τρόπο</li>
              <li>Μεταδίδετε ιούς ή κακόβουλο κώδικα</li>
              <li>Συλλέγετε δεδομένα χρηστών χωρίς άδεια</li>
              <li>Παραβιάζετε δικαιώματα πνευματικής ιδιοκτησίας</li>
              <li>Πραγματοποιείτε αντίστροφη μηχανική του ιστότοπου</li>
              <li>Χρησιμοποιείτε bots ή αυτοματοποιημένα εργαλεία</li>
              <li>Παρενοχλείτε άλλους χρήστες</li>
              <li>Υποδύεστε άλλα πρόσωπα ή οντότητες</li>
            </ul>

            <h3>2.3 Λογαριασμός Χρήστη</h3>
            <p>
              Για να πραγματοποιήσετε παραγγελίες, ενδέχεται να χρειαστεί να
              δημιουργήσετε λογαριασμό. Είστε υπεύθυνοι για τη διατήρηση της
              εμπιστευτικότητας του κωδικού πρόσβασής σας και για όλες τις
              δραστηριότητες που πραγματοποιούνται μέσω του λογαριασμού σας.
            </p>
          </section>

          <section>
            <h2>3. Προϊόντα και Υπηρεσίες</h2>

            <h3>3.1 Περιγραφές Προϊόντων</h3>
            <p>
              Καταβάλλουμε κάθε δυνατή προσπάθεια να εμφανίσουμε με ακρίβεια τα
              χρώματα και τις εικόνες των προϊόντων μας. Ωστόσο, δεν μπορούμε να
              εγγυηθούμε ότι η οθόνη του υπολογιστή σας θα εμφανίζει τα χρώματα
              με ακρίβεια.
            </p>

            <h3>3.2 Τιμολόγηση</h3>
            <p>
              Όλες οι τιμές αναγράφονται σε ευρώ (€) και περιλαμβάνουν ΦΠΑ,
              εκτός εάν αναφέρεται διαφορετικά. Διατηρούμε το δικαίωμα να
              τροποποιούμε τις τιμές ανά πάσα στιγμή, αλλά οι αλλαγές δεν θα
              επηρεάζουν παραγγελίες που έχουν ήδη επιβεβαιωθεί.
            </p>

            <h3>3.3 Διαθεσιμότητα</h3>
            <p>
              Όλες οι παραγγελίες υπόκεινται σε διαθεσιμότητα. Διατηρούμε το
              δικαίωμα να περιορίσουμε τις ποσότητες προϊόντων που πωλούνται σε
              οποιοδήποτε άτομο, νοικοκυριό ή παραγγελία.
            </p>
          </section>

          <section>
            <h2>4. Παραγγελίες και Πληρωμές</h2>

            <h3>4.1 Διαδικασία Παραγγελίας</h3>
            <p>
              Όταν υποβάλλετε παραγγελία, θα λάβετε email επιβεβαίωσης. Αυτό το
              email δεν συνιστά αποδοχή της παραγγελίας σας. Η αποδοχή της
              παραγγελίας θα επιβεβαιωθεί όταν τα προϊόντα αποσταλούν.
            </p>

            <h3>4.2 Μέθοδοι Πληρωμής</h3>
            <p>Αποδεχόμαστε τις ακόλουθες μεθόδους πληρωμής:</p>
            <ul>
              <li>
                Πιστωτικές/Χρεωστικές κάρτες (Visa, Mastercard, American
                Express)
              </li>
              <li>PayPal</li>
              <li>Τραπεζική μεταφορά</li>
              <li>Αντικαταβολή (όπου διατίθεται)</li>
            </ul>

            <h3>4.3 Ασφάλεια Πληρωμών</h3>
            <p>
              Όλες οι συναλλαγές είναι ασφαλείς και κρυπτογραφημένες. Δεν
              αποθηκεύουμε πληροφορίες πιστωτικών καρτών στους servers μας.
            </p>

            <h3>4.4 Ακύρωση Παραγγελίας</h3>
            <p>
              Μπορείτε να ακυρώσετε την παραγγελία σας εντός 24 ωρών από την
              υποβολή, εφόσον δεν έχει ήδη αποσταλεί. Επικοινωνήστε μαζί μας
              άμεσα στο{" "}
              <a href="mailto:sororin@hotmail.com">sororin@hotmail.com</a>.
            </p>
          </section>

          <section>
            <h2>5. Αποστολή και Παράδοση</h2>

            <h3>5.1 Χρόνοι Παράδοσης</h3>
            <p>
              Οι χρόνοι παράδοσης είναι ενδεικτικοί και δεν αποτελούν δεσμευτική
              εγγύηση. Τυπικά, οι παραδόσεις πραγματοποιούνται εντός:
            </p>
            <ul>
              <li>Εντός Ελλάδας: 2-5 εργάσιμες ημέρες</li>
              <li>Ευρωπαϊκή Ένωση: 5-10 εργάσιμες ημέρες</li>
              <li>Διεθνώς: 10-20 εργάσιμες ημέρες</li>
            </ul>

            <h3>5.2 Έξοδα Αποστολής</h3>
            <p>
              Τα έξοδα αποστολής υπολογίζονται με βάση τον προορισμό και το
              βάρος της παραγγελίας. Δωρεάν αποστολή για παραγγελίες άνω των €50
              εντός Ελλάδας.
            </p>

            <h3>5.3 Παρακολούθηση Αποστολής</h3>
            <p>
              Θα λάβετε αριθμό παρακολούθησης μέσω email μόλις η παραγγελία σας
              αποσταλεί, ώστε να μπορείτε να παρακολουθείτε την πορεία της.
            </p>
          </section>

          <section>
            <h2>6. Επιστροφές και Επιστροφές Χρημάτων</h2>
            <p>
              Για λεπτομερείς πληροφορίες σχετικά με την πολιτική επιστροφών
              μας, παρακαλούμε ανατρέξτε στην
              <a href="/refund-policy">
                {" "}
                Πολιτική Επιστροφών και Επιστροφής Χρημάτων
              </a>
              .
            </p>
            <p>Βασικά σημεία:</p>
            <ul>
              <li>Δικαίωμα επιστροφής εντός 14 ημερών</li>
              <li>Προϊόντα πρέπει να είναι στην αρχική τους κατάσταση</li>
              <li>Ορισμένα προϊόντα εξαιρούνται (προϊόντα υγιεινής)</li>
            </ul>
          </section>

          <section>
            <h2>7. Πνευματική Ιδιοκτησία</h2>
            <p>
              Όλο το περιεχόμενο του ιστότοπου, συμπεριλαμβανομένων κειμένων,
              γραφικών, λογότυπων, εικόνων, video, και λογισμικού, προστατεύεται
              από δικαιώματα πνευματικής ιδιοκτησίας και ανήκει στη Sororin ή
              στους δικαιοπάροχούς της.
            </p>
            <p>
              Απαγορεύεται η αναπαραγωγή, διανομή, τροποποίηση ή δημιουργία
              παράγωγων έργων χωρίς προηγούμενη γραπτή άδεια.
            </p>
          </section>

          <section>
            <h2>8. Εγγυήσεις και Αποποίηση Ευθυνής</h2>

            <h3>8.1 Εγγύηση Προϊόντων</h3>
            <p>
              Τα προϊόντα μας καλύπτονται από τις εγγυήσεις που προβλέπονται από
              το νόμο. Εγγυόμαστε ότι τα προϊόντα είναι ελεύθερα ελαττωμάτων
              κατά την παράδοση.
            </p>

            <h3>8.2 Περιορισμός Ευθύνης</h3>
            <p>
              Στο μέγιστο βαθμό που επιτρέπεται από το νόμο, η Sororin δεν θα
              είναι υπεύθυνη για:
            </p>
            <ul>
              <li>Έμμεσες, ειδικές ή παρεπόμενες ζημίες</li>
              <li>Απώλεια κερδών ή εσόδων</li>
              <li>Διακοπή επιχειρηματικής δραστηριότητας</li>
              <li>Απώλεια δεδομένων ή πληροφοριών</li>
            </ul>
            <p>
              Η συνολική ευθύνη μας περιορίζεται στην αξία της συγκεκριμένης
              παραγγελίας.
            </p>

            <h3>8.3 Ανωτέρα Βία</h3>
            <p>
              Δεν ευθυνόμαστε για καθυστερήσεις ή αδυναμία εκτέλεσης υποχρεώσεων
              λόγω περιστάσεων πέραν του ελέγχου μας (φυσικές καταστροφές,
              πανδημίες, πόλεμος, κυβερνητικές ενέργειες κ.λπ.).
            </p>
          </section>

          <section>
            <h2>9. Προστασία Δεδομένων</h2>
            <p>
              Η συλλογή και επεξεργασία των προσωπικών σας δεδομένων διέπεται
              από την
              <a href="/privacy-policy"> Πολιτική Απορρήτου</a> μας, η οποία
              είναι αναπόσπαστο μέρος των παρόντων όρων.
            </p>
            <p>
              Συμμορφωνόμαστε πλήρως με τον Γενικό Κανονισμό Προστασίας
              Δεδομένων (GDPR) και την ελληνική νομοθεσία περί προστασίας
              δεδομένων.
            </p>
          </section>

          <section>
            <h2>10. Δικαίωμα Υπαναχώρησης (14 ημέρες)</h2>
            <p>
              Σύμφωνα με την ευρωπαϊκή νομοθεσία για τις πωλήσεις εξ αποστάσεως,
              έχετε το δικαίωμα να υπαναχωρήσετε από τη σύμβαση εντός 14 ημερών
              χωρίς να χρειάζεται να αναφέρετε λόγο.
            </p>
            <p>
              Η προθεσμία των 14 ημερών αρχίζει από την ημέρα που εσείς ή τρίτο
              πρόσωπο που ορίζετε (εκτός από τον μεταφορέα) λαμβάνει τα προϊόντα
              σε κατοχή.
            </p>
          </section>

          <section>
            <h2>11. Επίλυση Διαφορών</h2>

            <h3>11.1 Εφαρμοστέο Δίκαιο</h3>
            <p>
              Οι παρόντες όροι διέπονται και ερμηνεύονται σύμφωνα με το ελληνικό
              δίκαιο και τις διατάξεις της Ευρωπαϊκής Ένωσης.
            </p>

            <h3>11.2 Αρμοδιότητα Δικαστηρίων</h3>
            <p>
              Για την επίλυση τυχόν διαφορών αρμόδια είναι τα δικαστήρια της
              Θεσσαλονίκης, Ελλάδα, εκτός εάν η νομοθεσία προστασίας καταναλωτή
              προβλέπει διαφορετικά.
            </p>

            <h3>11.3 Εναλλακτική Επίλυση Διαφορών</h3>
            <p>
              Ενθαρρύνουμε την επίλυση τυχόν διαφορών μέσω διαπραγμάτευσης και
              καλής πίστης. Μπορείτε επίσης να χρησιμοποιήσετε την πλατφόρμα ODR
              της Ευρωπαϊκής Επιτροπής: https://ec.europa.eu/consumers/odr
            </p>
          </section>

          <section>
            <h2>12. Ενημερωτικό Δελτίο (Newsletter)</h2>
            <p>
              Εγγραφόμενοι στο ενημερωτικό μας δελτίο, συναινείτε να λαμβάνετε
              εμπορικές ανακοινώσεις και προωθητικά μηνύματα. Μπορείτε να
              διαγραφείτε ανά πάσα στιγμή κάνοντας κλικ στον σύνδεσμο διαγραφής
              σε κάθε email ή επικοινωνώντας μαζί μας.
            </p>
          </section>

          <section>
            <h2>13. Αποζημίωση</h2>
            <p>
              Συμφωνείτε να αποζημιώσετε και να απαλλάξετε τη Sororin, τους
              διευθυντές, υπαλλήλους και αντιπροσώπους της από οποιεσδήποτε
              αξιώσεις, ζημίες, υποχρεώσεις ή έξοδα που προκύπτουν από:
            </p>
            <ul>
              <li>Παραβίαση αυτών των όρων</li>
              <li>Παραβίαση δικαιωμάτων τρίτων</li>
              <li>Παράνομη χρήση του ιστότοπου</li>
            </ul>
          </section>

          <section>
            <h2>14. Διαχωρισιμότητα</h2>
            <p>
              Εάν οποιαδήποτε διάταξη των παρόντων όρων κριθεί άκυρη ή μη
              εκτελεστή, οι υπόλοιπες διατάξεις θα παραμείνουν σε πλήρη ισχύ. Η
              άκυρη διάταξη θα αντικατασταθεί από έγκυρη που ανταποκρίνεται όσο
              το δυνατόν περισσότερο στην πρόθεση της αρχικής.
            </p>
          </section>

          <section>
            <h2>15. Ολοκλήρωση Συμφωνίας</h2>
            <p>
              Οι παρόντες όροι, μαζί με την Πολιτική Απορρήτου και την Πολιτική
              Επιστροφών, αποτελούν την πλήρη συμφωνία μεταξύ εσάς και της
              Sororin σχετικά με τη χρήση του ιστότοπου και υπερισχύουν όλων των
              προηγούμενων συμφωνιών.
            </p>
          </section>

          <section>
            <h2>16. Επικοινωνία</h2>
            <p>
              Για ερωτήσεις σχετικά με τους παρόντες όρους, επικοινωνήστε μαζί
              μας:
            </p>
            <div className="contact-info">
              <p>
                <strong>Sororin - Κατάστημα Ομορφιάς</strong>
              </p>
              <p>
                <strong>Email:</strong>{" "}
                <a href="mailto:sororin@hotmail.com">sororin@hotmail.com</a>
              </p>
              <p>
                <strong>Τηλέφωνο:</strong> +302394023553
              </p>
              <p>
                <strong>Διεύθυνση:</strong> Λεωφόρος Βενιζέλος, 2, Λαγκαδάς, 898
                60, Ελλάδα
              </p>
              <p>
                <strong>Ωράριο Εξυπηρέτησης:</strong> Δευτέρα - Κυριακή: 09:00 -
                21:00
              </p>
            </div>
          </section>

          <section>
            <p className="acceptance-note">
              <strong>Σημαντική Σημείωση:</strong> Χρησιμοποιώντας τον ιστότοπό
              μας, επιβεβαιώνετε ότι έχετε διαβάσει, κατανοήσει και συμφωνήσει
              με τους παρόντες Όρους και Προϋποθέσεις.
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default TermsConditions;
